import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from "react-router-dom";

import Footer from './components/footer/Footer';
import NavBar from './components/navBar/NavBar';
import Home from './components/home/Home';
import Band from './components/band/Band';
import Contact from './components/contact/Contact';
import Impress from './components/impress/Impress';
import './App.css';
import Blog from './components/blog/Blog';
import Music from './components/music/Music';

class App extends Component {

  constructor(props) {
    super();
    this.state = {
      viewIndex : -1
    }

    this.onUpdateHandler = this.onUpdateHandler.bind(this);
  }

  getInitialState() {
    return { viewIndex : -1 };
  }

  onUpdateHandler(event, newViewIndex) {
    console.log("Clicked on element: " + newViewIndex.toString());
    this.setState({viewIndex : newViewIndex});
  }

  render() {
    switch(this.state.viewIndex) {
      case 0:
        return (
          <div className="App">
            <Home/>
            <NavBar handler = {this.onUpdateHandler} />
            <Footer handler = {this.onUpdateHandler} />
          </div>
        );
      case 1:
        return (
          <div className="App">
            <Band/>
            <NavBar handler = {this.onUpdateHandler} />
            <Footer handler = {this.onUpdateHandler} />
          </div>
        );
      case 2:
        return (
          <div className="App">
            <Blog/>
            <NavBar handler = {this.onUpdateHandler} />
            <Footer handler = {this.onUpdateHandler} />
          </div>
        );
      case 3:
        return (
          <div className="App">
            <Music/>  
            <NavBar handler = {this.onUpdateHandler} />
            <Footer handler = {this.onUpdateHandler} />
          </div>
        );
      case 4:
        return (
          <div className="App">
            <Contact/>
            <NavBar handler = {this.onUpdateHandler} />
            <Footer handler = {this.onUpdateHandler} />
          </div>
        );
      case 100:
        return (
          <div className="App">
            <Impress/>
            <NavBar handler = {this.onUpdateHandler} />
            <Footer handler = {this.onUpdateHandler} />
          </div>
        );
      default:
        return (
          <div className="App">
            <Router>
              <Route path="/" exact component={Home} />
              <Route path="/band/" exact component={Band} />
              <Route path="/blog/" exact component={Blog} />
              <Route path="/contact/" component={Contact} />
              <Route path="/music/" component={Music} />
              <Route path="/impress/" component={Impress} />
            </Router>
            <NavBar handler = {this.onUpdateHandler} />
            <Footer handler = {this.onUpdateHandler} />
          </div>
        );
    }
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js